import React, {useState, useCallback, useEffect, useContext} from 'react';
import DashboardMain_Bus from '../DashboardMain_Bus/DashboardMain_Bus';
import FilterSection from './FilterSection';
import '../Faultanalysis_BusNew/FaultFirstPage/FaultFirstPageCustom_bus.css';
import { decodeToken } from 'react-jwt';
import { INIT_FILTER_STATE } from '../../../constants/driveglobalfilterinitalstates_bus';
import useHttp from '../../../hook/use-http';
import { API_URL_MAIN } from '../../../constants/driveglobalfilterinitalstates_bus';
import AppContext from '../../../store/AppContext';
import RangeAnalysis from './RangeAnalysis/RangeAnalysis';
import FirstSection from './FirstSection';
import MonthChart from './DischargeAnalysis/MonthChart';
import ThirdSection from './ThirdSection/ThirdSection';
import RangeSocAnalysis from './DischargeAnalysis/RangeSocAnalysis';
import RangeEnergyAnalysis from './EnergyAnalysis/RangeEnergyAnalysis';
import KpiSection from './KpiSection/KpiSection';
import RangeRegAnalysis from './RegenerationAnalysis/RangeRegAnalysis';


export default function TrendAnalysisMainBus() {
    const tokenNew = JSON.parse(sessionStorage.user);
    let decodedToken = decodeToken(tokenNew.token);
    const city_name = decodedToken.city_name;
    const city_name_arr = city_name.split(",");
    const depo_name = decodedToken.depo_name;
    const depo_name_arr = depo_name.split(",");
    let sampleObj = (city_name !== "") ? { ...INIT_FILTER_STATE, CITY: city_name_arr, DEPO: depo_name_arr } : INIT_FILTER_STATE
  
    const [gloablfilter, setGloablfilter] = useState(sampleObj);
    const { isLoading, error, sendReq: fetchData } = useHttp();
    const [titleSelected, setTitleSelected] = useState('En_Reg');

    const app_ctx = useContext(AppContext);
    const log_data = (data) => {
    }

    useEffect(() => {
        fetchData({
          url: API_URL_MAIN + "auth/logging", body: {
            page_name: "Trend_Analysis"
    
          }
        }, log_data)
      }, []);

    const filterSubmited = useCallback((data) => {
        setGloablfilter(data);
    }, []);

    const onreset = (data) => {
        setGloablfilter(data);
    }

    const singleVinSelected = (vin) => {
        let vin_num = vin.split(",");
        setGloablfilter((prevdata) => { return { ...prevdata, VIN_NUM: vin_num, pageSelected: 2 } });
    }

    const pageChange = () => {
      setGloablfilter((prevdata) => {
        return { ...prevdata, pageSelected: 1, VIN_NUM: [] }
      });
    }

    const onTitle = (selectTitle) =>{
      setTitleSelected(selectTitle);
    }

    if (gloablfilter.pageSelected === 1) {
        return (
          <>
            <DashboardMain_Bus>
                {/* <FilterSection onsubmit={filterSubmited} gloablfilter={gloablfilter} onreset={onreset}/> */}
                <div className="container-fluid busdrpg1">
                  {/* <FirstSection gloablfilter={gloablfilter}/> */}
                  <KpiSection gloablfilter={gloablfilter}/>
                  <RangeAnalysis gloablfilter={gloablfilter}/>
                  <div className='row mt-0'>
                    {(titleSelected === 'SOC')?
                      <div className='col-md-6'><RangeSocAnalysis gloablfilter={gloablfilter} onreset={onTitle}/></div>
                      :
                      <div className='col-md-6'><RangeRegAnalysis gloablfilter={gloablfilter} onreset={onTitle}/></div>
                    }
                    
                    <div className='col-md-6 pl-md-0'><RangeEnergyAnalysis gloablfilter={gloablfilter}/></div>
                  </div>
                  <ThirdSection gloablfilter={gloablfilter}/>
                </div>
            </DashboardMain_Bus>
          </>
        );
      }
}
